// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Select_wrapper__zJHhe","select":"Select_select__2VA3G","label":"Select_label__XCdKq","error":"Select_error__3Z9Ty","input_error":"Select_input_error__2qB43"};